Configuration.$inject = ['datepickerConfig', 'datepickerPopupConfig'];

export function Configuration(datepickerConfig, datepickerPopupConfig) {
        datepickerConfig.startingDay = 1;
        datepickerPopupConfig.showButtonBar = false;
    }
